"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Vue, Component, PropSync } from "vue-property-decorator";
import VirtualDesktopItem from "./VirtualDesktopItem.vue";
import { Debounce } from "vue-debounce-decorator";
let VirtualDesktopItemBody = class extends Vue {
  mounted() {
  }
  createShop(data) {
    this.$emit("createShop", data);
  }
  moveShop(data) {
    this.$emit("moveshop", data);
  }
  editShop(data) {
    this.$emit("editshop", data);
  }
  changeName(data) {
    this.$emit("changename", data);
  }
  bindIP(data) {
    this.$emit("bindIP", data);
  }
  proxySetting(data) {
    this.$emit("proxySetting", data);
  }
  chooseAdmin(data) {
    this.$emit("chooseAdmin", data);
  }
  editGroup(data) {
    this.$emit("editGroup", data);
  }
  unstickToTop(data) {
    this.$emit("unstickToTop", data);
  }
  stickToTop(data) {
    this.$emit("stickToTop", data);
  }
  clearCache(data) {
    this.$emit("clearCache", data);
  }
  deleteVD(data) {
    this.$emit("deleteVD", data);
  }
  realDeleteVD(data) {
    this.$emit("realDeleteVD", data);
  }
  moveVD(data) {
    this.$emit("moveVD", data);
  }
  remoteLauncher(data) {
    this.$emit("remoteLauncher", data);
  }
  proxyShare(data) {
    this.$emit("proxyShare", data);
  }
  changeUpPage() {
    return __async(this, null, function* () {
      this._controller.query.current -= 1;
      yield this._controller.search();
    });
  }
  changeNextPage() {
    return __async(this, null, function* () {
      this._controller.query.current += 1;
      yield this._controller.search();
    });
  }
  setFavorite(column) {
    this.$emit("setFavorite", column);
  }
  setUnFavorite(column) {
    this.$emit("setUnFavorite", column);
  }
  openForceDialog(item) {
    this.$emit("openForceDialog", item);
  }
  toUrge(item) {
    this.$emit("urge", item);
  }
};
__decorateClass([
  PropSync("controller")
], VirtualDesktopItemBody.prototype, "_controller", 2);
__decorateClass([
  Debounce(600)
], VirtualDesktopItemBody.prototype, "changeUpPage", 1);
__decorateClass([
  Debounce(600)
], VirtualDesktopItemBody.prototype, "changeNextPage", 1);
VirtualDesktopItemBody = __decorateClass([
  Component({
    components: {
      VirtualDesktopItem
    }
  })
], VirtualDesktopItemBody);
export {
  VirtualDesktopItemBody as default
};
